import { SecondsHandType } from "../constants/seconds-hand-types";
import { SelectionColours } from "../constants/selection-colors";

export const classStringBuilder = (classList1, classList2) =>
  [...classList1, ...classList2].join(" ");

export const isSpecial = (value) => value === SecondsHandType.SPECIAL;

export const conditionallyAddStyles = (
  truthy,
  defaultClasses,
  trueClasses = "",
  falseClasses = ""
) => {
  if (truthy) {
    const trueClassesArray = trueClasses.split(" ");
    defaultClasses.push(...trueClassesArray);
  } else {
    const falseClassesArray = falseClasses.split(" ");
    defaultClasses.push(...falseClassesArray);
  }
};

export const isColorWhite = (colors) =>
  colors.some((color) => color === SelectionColours.WHITE);

export const getPriceFromVariant = (variant) =>
  convertPenceToGBP(variant.price * 1.2);

export const convertPenceToGBP = (pence) =>
  new Intl.NumberFormat("en-UK", { style: "currency", currency: "GBP" }).format(
    pence / 100
  );

export const createSelectionTitleString = (
  key,
  selectionText,
  selectionTitle
) => {
  if (key === "engraving") {
    return selectionText === "" ? "NONE" : selectionText;
  }

  if (key === "initials") {
    return selectionText === ""
      ? "NONE"
      : `${selectionText} - ${selectionTitle}`;
  }

  return selectionTitle.toUpperCase();
};

export const isValueSteelColor = (value) =>
  ["steelSilver", "steelBlack"].some((key) => key === value);
